<template>
    <q-header class="shadow-5">
        <q-toolbar>
            <q-icon
                color="blue-grey"
                name="fas fa-bars"
                size="sm"
                @mouseover="openDrawer"
                data-test="drawer-menu"
            />
            <img
                src="@/assets/nova-logo-controlsul.png"
                class="logo"
                alt="Logo Controlsul"
            />
            <q-separator class="text-secondary" vertical inset />
            <q-toolbar-title
                class="text-secondary rt-header-title"
                data-test="header-title"
                :title="title"
            >
                <b>{{ title }}</b>
                <q-tooltip v-if="title">{{ title }}</q-tooltip>
            </q-toolbar-title>
            <q-space />
            <div class="rt-header-actions">
            <div v-for="btn of options" :key="btn.name" class="text-secondary">
                <q-btn-dropdown
                    stretch
                    flat
                    :label="btn.name"
                    v-if="btn.type === 'dropdown2'"
                    :icon="btn.icon"
                    size="10px"
                    :data-test="`header-menu-dropdown-${btn.name
                        .toLowerCase()
                        .replace(/\s+/g, '-')}`"
                >
                    <q-list>
                        <q-item-label header>{{ btn.name }}</q-item-label>
                        <q-item v-for="item of btn.items" :key="item.name">
                            <q-item-section>
                                <q-item-label>{{ item.name }}</q-item-label>
                                <q-item-label caption>{{
                                    item.caption
                                }}</q-item-label>

                                <q-list>
                                    <q-item
                                        v-for="opt of item.options"
                                        :key="opt.name"
                                        clickable
                                        v-close-popup
                                        @click="() => handleClick(opt.value)"
                                        :data-test="`header-menu-item-${opt.name
                                            .toLowerCase()
                                            .replace(/\s+/g, '-')}`"
                                    >
                                        <q-item-section avatar>
                                            <q-avatar
                                                :icon="opt.icon"
                                                color="secondary"
                                                text-color="white"
                                            />
                                        </q-item-section>
                                        <q-item-section>
                                            <q-item-label>{{
                                                opt.name
                                            }}</q-item-label>
                                            <q-item-label caption>{{
                                                opt.caption
                                            }}</q-item-label>
                                        </q-item-section>
                                    </q-item>
                                </q-list>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
                <q-btn-dropdown
                    stretch
                    flat
                    :label="btn.name"
                    v-if="btn.type === 'dropdown'"
                    :icon="btn.icon"
                    size="10px"
                    :data-test="`header-menu-dropdown-${btn.name
                        .toLowerCase()
                        .replace(/\s+/g, '-')}`"
                >
                    <q-list>
                        <q-item-label header>{{ btn.name }}</q-item-label>
                        <q-item
                            v-for="item of btn.items"
                            :key="item.name"
                            :clickable="!item.disable"
                            :disable="!!item.disable"
                            v-close-popup
                            @click="() => !item.disable && handleClick(item.value)"
                            :data-test="`header-menu-item-${item.name
                                .toLowerCase()
                                .replace(/\s+/g, '-')}`"
                        >
                            <q-item-section avatar>
                                <q-avatar
                                    :icon="item.icon"
                                    color="secondary"
                                    text-color="white"
                                />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ item.name }}</q-item-label>
                                <q-item-label caption>{{
                                    item.caption
                                }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
                <q-btn
                    v-if="btn.type === 'simple'"
                    stretch
                    flat
                    :label="btn.name"
                    :icon="btn.icon"
                    size="10px"
                    @click="() => handleClick(btn.value)"
                    :data-test="`header-menu-button-${btn.name
                        .toLowerCase()
                        .replace(/\s+/g, '-')}`"
                />
            </div>
            <div class="text-secondary">
                <q-btn
                    stretch
                    flat
                    label="Perfil"
                    icon="fas fa-user"
                    size="10px"
                    @click="pushAccount"
                    data-test="header-account-button"
                />
                <q-btn-dropdown
                    v-if="showIcmsExclusionHelpMenu"
                    stretch
                    flat
                    label="Ajuda"
                    icon="fas fa-question"
                    size="10px"
                    data-test="help-button"
                >
                    <q-list>
                        <q-item
                            v-for="item of icmsExclusionHelpItems"
                            :key="item.action"
                            clickable
                            v-close-popup
                            @click="handleIcmsExclusionHelpAction(item.action)"
                            :data-test="item.dataTest"
                        >
                            <q-item-section avatar>
                                <q-avatar
                                    :icon="item.icon"
                                    color="secondary"
                                    text-color="white"
                                />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ item.name }}</q-item-label>
                                <q-item-label caption>{{ item.caption }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
                <q-btn
                    v-else
                    stretch
                    v-show="validPage"
                    flat
                    label="Ajuda"
                    icon="fas fa-question"
                    size="10px"
                    @click="pushHelp()"
                    data-test="help-button"
                />
            </div>
            </div>
        </q-toolbar>
    </q-header>
</template>

<script>
import { jwtDecode } from 'jwt-decode'

/** Posição de scroll ao abrir a ajuda a partir da rota de origem. */
const HELP_PAGE_SCROLL_TOP = {
    '/funds/import-manad': 2060,
    '/funds/classify-rubrics': 4250,
    '/funds/generate-calculations': 5620,
    '/funds/export-rubrics': 8280,
    '/funds/list-calculations': 9250,
    '/subsidy/import-sped': 2500,
    '/subsidy/calculate-simplified': 5200,
    '/subsidy/generate-items-data': 7310,
    '/subsidy/classify-items': 9030,
    '/subsidy/generate-calculations': 9800,
    '/subsidy/data-validation-list': 12000,
    '/subsidy/calculations-list': 12900,
    '/credit-pis-cofins/import-sped': 850,
    '/credit-pis-cofins/import-xml': 4350,
    '/credit-pis-cofins/xml-list': 5725,
    '/credit-pis-cofins/calculate': 10130,
    '/credit-pis-cofins/export-xml-list': 14100,
    '/credit-pis-cofins/export-calculations': 15000,
    simple_cad_client: 600,
    '/simple/import-sped': 800,
    '/simple/analyze-suppliers': 4760,
    '/simple/classify-products': 7700,
    '/simple/generate-calculations': 10150,
    '/simple/export-supplier-analysis-list': 15200,
    '/simple/export-calculations-list': 16310,
    '/reforma-tributaria/clientes': 5343,
    '/reforma-tributaria/diagnosticos': 7866,
    '/reforma-tributaria/diagnosticos/novo': 9099,
    '/reforma-tributaria/parametros/reforma': 20590,
    '/reforma-tributaria/parametros/limite-simples': 23041,
    '/forms': 1746,
    '/forms/forms-history': 3438,
    '/icms-exclusion/database-validation': 3048,
    '/icms-exclusion/import-sped': 6084,
    '/icms-exclusion/import-sped/list': 6084,
    '/icms-exclusion/extract-data': 9607,
    '/icms-exclusion/generate-calculations': 23503,
    '/icms-exclusion/export-calculations': 26268,
}

const ICMS_EXCLUSION_HELP_ROUTES = {
    docs: () => ({ path: `/help/icms-exclusion` }),
    demos: () => ({ path: '/help/icms-exclusion/demos' }),
    tour: () => ({
        path: '/icms-exclusion/tour/database-validation',
        query: { guided: '1' },
    }),
}

export default {
    name: 'Header',

    props: {
        options: {
            type: Array,
        },
        pageValue: String,
        validPage: String,

        title: {
            type: String,
        },
        routing: Boolean,
    },

    data() {
        return {
            showPopup: false,
            route: '',
            icmsExclusionHelpItems: [
                {
                    action: 'docs',
                    name: 'Documentação de ajuda',
                    caption: 'Guia completo do módulo',
                    icon: 'fas fa-book',
                    dataTest: 'help-icms-exclusion-docs',
                },
                {
                    action: 'demos',
                    name: 'Demonstrações em vídeo',
                    caption: 'Vídeos e passo a passo por etapa',
                    icon: 'fas fa-play-circle',
                    dataTest: 'help-icms-exclusion-demos',
                },
                {
                    action: 'tour',
                    name: 'Tour guiado',
                    caption: 'Demonstração interativa no sistema',
                    icon: 'fas fa-route',
                    dataTest: 'help-icms-exclusion-tour',
                },
            ],
        }
    },

    computed: {
        showIcmsExclusionHelpMenu() {
            return this.validPage && this.pageValue === 'icms-exclusion'
        },
    },

    async created() {
        const { email } = jwtDecode(localStorage.getItem('tk_3000'))
        this.userEmail = this.$store.getters.GET_EMAIL || email
    },

    methods: {
        openDrawer() {
            const drawerState = this.$store.getters.GET_DRAWER
            if (!drawerState) {
                this.$store.dispatch('SET_DRAWER', true)
            }
        },

        handleClick(page) {
            if (this.routing) {
                this.changePage(page)
            } else {
                this.changeTab(page)
            }
        },
        changePage(page) {
            this.$store.dispatch('RESET_STATE')
            this.$router.replace(page)
        },
        changeTab(tab) {
            this.$emit('setMenu', tab)
        },
        goto(refName) {
            const element = this.$refs[refName]
            const top = element.offsetTop

            window.scrollTo(0, top)
        },

        pushAccount() {
            this.$router.push('/account')
        },

        handleIcmsExclusionHelpAction(action) {
            if (action === 'docs') {
                this.pushHelp()
                return
            }

            const route = ICMS_EXCLUSION_HELP_ROUTES[action]?.()
            if (route) {
                this.$router.push(route).catch(() => {})
            }
        },

        async pushHelp() {
            const currentRoute = this.$route.path

            await this.$router.push({ path: `/help/${this.pageValue}` }).catch(() => {})

            const scrollTop = HELP_PAGE_SCROLL_TOP[currentRoute] ?? 0
            window.scrollTo(0, scrollTop)
        },
    },
}
</script>

<style>
span.block {
    font-weight: bold;
}

.teste {
    background-color: red;
}
.logo {
    margin-right: 0.7rem;
    margin-left: 1rem;
    flex-shrink: 0;
}

.q-toolbar__title.rt-header-title {
    /* Encolhe antes dos botões. O texto que não cabe vira reticências. */
    flex: 1 1 auto;
    flex-shrink: 999;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.q-toolbar__title.rt-header-title b {
    font-size: 20px;
    font-weight: 700;
}

.rt-header-actions {
    display: flex;
    flex: 0 1 auto;
    align-self: stretch;
    align-items: stretch;
    min-width: 0;
    overflow-x: auto;
    scrollbar-width: none;
}

.rt-header-actions::-webkit-scrollbar {
    display: none;
}

.rt-header-actions > div {
    flex: 0 0 auto;
    display: flex;
    align-items: stretch;
}
</style>
